import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// import axios from 'axios'

import vuetify from '@/plugins/vuetify'
import VueMatomo from 'vue-matomo'

Vue.config.productionTip = false
// axios.defaults.withCredentials = true

Vue.prototype.$appVersion = '0.9.9（ベータ版）'

Vue.use(VueMatomo, {
  host: 'https://matomo.lakesoft.jp/matomo',
  siteId: 1
  // requireConsent: true
  // router: router
})

// console.log('process.env.VUE_APP_ENV', process.env.VUE_APP_ENV)

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
